import React, { useState } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import GoogleTranslate from "./GoogleTranslate";
import GoogleTranslateMobile from "./GoogleTranslateMobile";

export default function Navbar(props) {
  const [isLightMode, setIsLightMode] = useState(props.mode === "light");
  const [isCollapsed, setIsCollapsed] = useState(true);

  const handleToggleMode = () => {
    setIsLightMode(!isLightMode);
    props.toggleMode();
  };

  const handleLinkClick = () => {
    setIsCollapsed(true); // Close the toggle menu
  };

  return (
    <>
      <nav
        className={`navbar navbar-expand-lg navbar-${props.mode} sticky-top py-2 bg-${ props.mode === "light" ? "light" : "navbar-bg"}`}
      >
        <div className="container-fluid">
          <NavLink
            className="navbar-brand d-flex align-items-center"
            to="/"
            onClick={handleLinkClick}
          >
            {props.mode === "light" ? (
              <img src={props.logoSrcBlack} alt="" className="img-fluid logo" />
            ) : (
              <img src={props.logoSrcWhite} alt="" className="img-fluid logo" />
            )}
          </NavLink>
          <button
            className="navbar-toggler"
            type="button"
            onClick={() => setIsCollapsed(!isCollapsed)}
            aria-controls="navbarSupportedContent"
            aria-expanded={!isCollapsed}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className={`collapse navbar-collapse ${isCollapsed ? "" : "show"}`}
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  activeclassname="active"
                  aria-current="page"
                  to="/"
                  onClick={handleLinkClick}
                >
                  {props.home}
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/portfolio-list"
                  activeclassname="active"
                  onClick={handleLinkClick}
                >
                  {props.portfolio}
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/about"
                  activeclassname="active"
                  onClick={handleLinkClick}
                >
                  {props.about}
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/Contact"
                  activeclassname="active"
                  onClick={handleLinkClick}
                >
                  {props.contact}
                </NavLink>
              </li>
            </ul>
            <div className="rightNav web-rightNav">
              <GoogleTranslate />
              <div
                className={`form-switch mx-3 mb-4 mb-md-0 text-${isLightMode ? "dark" : "light"
                  } d-flex justify-content-between align-items-center themeButton`}
              >
                {/* <input
                    className="checkbox"
                    type="checkbox"
                    role="switch"
                    id="toggle1"
                    onChange={handleToggleMode}
                    checked={isLightMode}
                  /> */}
                <input type="checkbox" className="checkbox" id="checkbox" onChange={handleToggleMode}
                  checked={isLightMode}></input>
                <label htmlFor="checkbox" className="checkbox-label">
                  <i className="fas fa-moon"></i>
                  <i className="fas fa-sun"></i>
                  <span className="ball"></span>
                </label>
              </div>
            </div>
          </div>
        </div>

        {/* language and theme in footer for small screen */}
        <div className="rightNav mobile-rightNav">
          <GoogleTranslateMobile />
          <div
            className={`form-switch mx-3 mb-4 mb-md-0 text-${isLightMode ? "dark" : "light"
              } d-flex justify-content-between align-items-center`}
          >
            <span>
              <i className="fa fa-moon"></i>
            </span>
            <span className="toggleBtn">
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                id="toggle1"
                onChange={handleToggleMode}
                checked={isLightMode}
              />
            </span>
            <span className="form-check-label">
              <i className="fa fa-sun"></i>
            </span>
          </div>
        </div>
      </nav>
    </>
  );
}

Navbar.propTypes = {
  mode: PropTypes.string.isRequired,
  toggleMode: PropTypes.func.isRequired,
  logoSrcBlack: PropTypes.string.isRequired,
  logoSrcWhite: PropTypes.string.isRequired,
  emailImg: PropTypes.string.isRequired,
  emailImg2: PropTypes.string.isRequired,
  home: PropTypes.string,
  about: PropTypes.string,
  contact: PropTypes.string,
  searchPlaceholder: PropTypes.string,
  search: PropTypes.string,
  services: PropTypes.string,
  service1: PropTypes.string,
  service2: PropTypes.string,
  service3: PropTypes.string,
  service4: PropTypes.string,
  service5: PropTypes.string,
  service6: PropTypes.string,
  service7: PropTypes.string,
  service8: PropTypes.string,
  service9: PropTypes.string,
  portfolio: PropTypes.string,
  team: PropTypes.string,
  blog: PropTypes.string,
};
